import React, { useState } from 'react';
import { Send, CheckCircle, AlertCircle } from 'lucide-react';
import './ContactUs.css';

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        query: ''
    });
    const [status, setStatus] = useState({ type: '', message: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setStatus({ type: '', message: '' });

        try {
            // Use dedicated contact API URL (Vercel backend for email support)
            const CONTACT_API_URL = process.env.REACT_APP_CONTACT_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
            const response = await fetch(`${CONTACT_API_URL}/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok) {
                setStatus({ type: 'success', message: 'Your message has been sent successfully!' });
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    query: ''
                });
            } else {
                setStatus({ type: 'error', message: data.message || 'Something went wrong. Please try again.' });
            }
        } catch (error) {
            setStatus({ type: 'error', message: 'Failed to connect to the server.' });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contact-page">
            <section className="contact-hero">
                <div className="container">
                    <h1 className="contact-title">Contact Us</h1>
                    <p className="contact-subtitle">
                        We'd love to hear from you. Get in touch with us for any queries or support.
                    </p>
                </div>
            </section>

            <div className="contact-container">
                <div className="contact-info">
                    <h2>Get in Touch with TravelB2B Hub</h2>
                    <p>
                        At TravelB2B Hub, we’re here to help you with any issues related to service listings,
                        platform usage, or general queries. If you face any difficulty while posting a travel
                        B2B service or connecting with service providers, feel free to reach out to us.
                    </p>
                    <p>
                        Simply fill out the contact form below and our team will get back to you as soon as possible.
                    </p>
                </div>

                <div className="contact-form-card">
                    {status.message && (
                        <div className={`form-message ${status.type}`}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                {status.type === 'success' ? <CheckCircle size={18} /> : <AlertCircle size={18} />}
                                {status.message}
                            </div>
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="name">Name *</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className="form-input"
                                placeholder="Enter your name"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">Email *</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="form-input"
                                placeholder="Enter your email"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="phone">Phone Number *</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={(e) => {
                                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                    setFormData(prev => ({ ...prev, phone: numericValue }));
                                }}
                                className="form-input"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                maxLength="10"
                                placeholder="Enter 10 digit number"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="query">Query *</label>
                            <textarea
                                id="query"
                                name="query"
                                value={formData.query}
                                onChange={handleChange}
                                className="form-textarea"
                                required
                                placeholder="How can we help you?"
                            ></textarea>
                        </div>

                        <button type="submit" className="submit-btn" disabled={isSubmitting}>
                            {isSubmitting ? 'Sending...' : (
                                <>
                                    <Send size={18} />
                                    Send Message
                                </>
                            )}
                        </button>
                    </form>
                </div >
            </div >
        </div >
    );
};

export default ContactUs;
